export interface IDeal {
	title?: string;
	owner?: number;
	pipeline?: string;
	primaryContact?: number;
	primaryCompany?: number;
	status?: string;
	stage?: string;
	source?: string;
	estimatedCloseDate?: string;
	dealValue?: number;
	currency?: string;
	priority?: string;
	description?: string;
	tags?: string;
}
